import { createSlice } from "@reduxjs/toolkit";
import { ignoreListReducers } from "slices/settings/helpers";

const initialState = {
  editMode: false,
  ignoreList: [], // [{term: "", regex: false, newlyCreated: ""]}
  unchangedIgnoreList: [],
  lastUpdated: "",
  updatedBy: "",
  hasBeenEdited: false,
  locked: false,
  selectedIndex: 0,
  showRegex: false,
  ignoreListItem: {}, // {term: "", regex: false, newlyCreated: ""}
};

export const acronymIgnoreSlice = createSlice({
  name: "acronymIgnore",
  initialState,
  reducers: {
    setEditMode: ignoreListReducers.setEditMode,
    setEditedList: ignoreListReducers.setEditedList,
    deleteTerm: ignoreListReducers.deleteTerm,
    cancelEdits: ignoreListReducers.cancelEdits,
    setLocked: ignoreListReducers.setLocked,
    setIgnoreList: (state, action) => {
      state.ignoreList = action.payload.ignoreList.map((item) => ({
        term: item.ignoreWord,
        regex: item.regex,
        newlyCreated: false,
      }));
      state.lastUpdated = action.payload.lastUpdated;
      state.updatedBy = action.payload.updatedBy;
      state.hasBeenEdited = false;
      state.locked = action.payload.locked;
      state.unchangedIgnoreList = [];
    },
    addNewTerm: (state, action) => {
      const index = action.payload;
      const updatedList = [...state.ignoreList];
      updatedList.splice(index + 1, 0, {
        term: "",
        regex: false,
        newlyCreated: true,
      });

      state.ignoreList = updatedList;
      state.selectedIndex = index + 1;
    },
    editItem: (state, action) => {
      state.hasBeenEdited = true;
      state.ignoreList = state.ignoreList.map((item, index) => {
        if (index === action.payload.index) {
          return action.payload.editedItem;
        }
        return item;
      });
    },
    setRegexPanel: (state, action) => {
      state.showRegex = action.payload.showRegex;
      state.ignoreListItem = action.payload.ignoreListItem;
    },
  },
});

export const {
  setEditMode,
  setEditedList,
  deleteTerm,
  cancelEdits,
  setLocked,
  setIgnoreList,
  addNewTerm,
  setRegexPanel,
  editItem,
} = acronymIgnoreSlice.actions;

export default acronymIgnoreSlice.reducer;
